export type PublishedChapterCandidate = {
  order?: number | null;
  isPublished?: boolean;
  status?: 'draft' | 'published' | string | null;
};

export function isPublishedChapter(chapter: PublishedChapterCandidate): boolean {
  if (chapter.status === 'draft') return false;
  if (chapter.isPublished === false) return false;
  return true;
}

/** Index in the reader list of the published chapter with the highest order. */
export function getLastPublishedChapterIndex(chapters: PublishedChapterCandidate[]): number {
  let bestIndex = -1;
  let bestOrder = Number.NEGATIVE_INFINITY;

  chapters.forEach((chapter, index) => {
    if (!isPublishedChapter(chapter)) return;
    const order = chapter.order ?? index;
    if (order > bestOrder || (order === bestOrder && index > bestIndex)) {
      bestOrder = order;
      bestIndex = index;
    }
  });

  return bestIndex;
}

/**
 * Open the finish-reading prompt only when this chapter's saved progress
 * first crosses into 100% and the chapter is the last published one.
 * Progress must already be normalized (>99 becomes 100).
 */
export function shouldPromptWorkReview({
  chapterIndex,
  lastPublishedChapterIndex,
  previousProgress,
  nextProgress,
}: {
  chapterIndex: number;
  lastPublishedChapterIndex: number;
  previousProgress: number;
  nextProgress: number;
}): boolean {
  if (chapterIndex < 0 || chapterIndex !== lastPublishedChapterIndex) return false;
  return previousProgress < 100 && nextProgress >= 100;
}
